import React, { Component } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';

import FormView from '../../../Globals/Modals/FormView';
import FormEdit from '../../../Globals/Modals/FormEdit';

import loader from '../../../assets/loader.gif';
import exit from '../../../assets/icons/white/exit.png';

export default class FormsList extends Component {
  constructor(props) {
    super();
    this.state = {
      spRecord: [],
      loading: false,
      forms: [],
      viewType: '',
      formData: {},
      oldViewType: '',
    }
  }

  formatList = () => {
    console.log('loading form history');
    let formHistory;
    if (this.props.currentRecord['Form History']) {
      // formHistory = this.props.currentRecord['Form History'];
      formHistory = JSON.parse(this.props.currentRecord['Form History'].toString());

      formHistory = formHistory.reverse();

      this.setState({
        forms: formHistory,
      })
    }

    console.log(formHistory);
  }

  openForm = (f) => {
    this.setState({
      formData: f,
      viewType: 'form',
      oldViewType: '',
    })
  }
  addForm = () => {
    this.setState({
      oldViewType: this.state.viewType,
      viewType: 'add',
    })
  }
  closeFormHandler = () => {
    if (this.state.viewType === 'add') {
      this.setState({
        oldViewType: '',
        viewType: this.state.oldViewType,
      })
    } else {
      this.setState({
        formData: {},
        viewType: this.state.oldViewType,
      })
    }


    let theForms = document.getElementsByClassName('formItem');
    for (var i in theForms) {
      if (theForms[i].classList) {
        theForms[i].classList.remove('isActive');
      }
    }
  }

  changeForm = (e) => {
    let theForms = document.getElementsByClassName('formItem');


    for (var i in theForms) {
      if (theForms[i].classList) {
        theForms[i].classList.remove('isActive');
      }
    }

    e.target.closest('.formItem').classList.add('isActive');
  }


  submitForm = (forms, newForm) => {
    this.setState({
      viewType: '',
    })
    setTimeout((function() {
      this.props.updateAfterForm(forms, newForm);

      setTimeout((function() {
        this.formatList();
      }).bind(this), 250);
    }).bind(this), 5);



  }

  componentDidMount() {
    this.formatList();
  }
  // Render
  // ----------------------------------------------------
  render() {
    const { currentRecord } = this.props;

    if (this.state.loading) {
      return (
        <div className="ModuleCard cardFull">
          <div className="fullInner">
            <div className="inner">
              <img src={loader} alt="" className="loader" />
            </div>
          </div>
        </div>
      )
    }

    let theCardClass = 'ModuleCard cardFull'
    if (this.state.viewType === 'form') {
      theCardClass += ' openedForm';
    }

    return (
      <div className={theCardClass}>
        <div className="fullInner">
          <div className="inner">
            <div className="btn softGrad--black addForm" onClick={()=>this.addForm()}>Add New Form +</div>
            {this.state.forms.length > 0 ? <h3 className="listHead">Form History</h3> : ''}

            <div className="theForms" onClick={this.changeForm}>
              {this.state.forms.length > 0 ? this.state.forms.map((e, i) => this.getForms(e, i)) : ''}
            </div>
          </div>
        </div>

        <FormView
          viewType={this.state.viewType}
          formData={this.state.formData}
          closeFormHandler={this.closeFormHandler}
        />

        <FormEdit
          viewType={this.state.viewType}
          formData={this.state.formData}
          closeFormHandler={this.closeFormHandler}
          currentRecord={this.props.currentRecord}
          spList={this.props.spList}
          spChangeHandler={this.props.spChangeHandler}
          recordId={this.props.recordId}
          baseId={this.props.baseId}
          submitForm={this.submitForm}
        />
      </div>
    )
  }


  getForms(form, i) {
    let formDate = new Date(form.date);
    let theMins = formDate.getMinutes();
    if (formDate.getMinutes() < 10) {
      theMins = "0" + formDate.getMinutes();
    }
    if (formDate.getHours() > 12) {
      formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + (formDate.getHours() - 12) + ':' + theMins + 'pm';
    } else {
      let theHours = formDate.getHours();
      if (formDate.getHours() === 0) {
        theHours = 12;
      }

      if (formDate.getHours() === 12) {
        formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + theHours + ':' + theMins + 'pm';
      } else {
        formDate = (formDate.getMonth()+1) + '/' + formDate.getDate() + '/' + formDate.getFullYear() + ' at ' + theHours + ':' + theMins + 'am';
      }
    }

    let formClasses = 'formItem ';
    let formHighlight = '';
    if (form.type === 'Account Increase') {
      formClasses += 'Increase';
    } else if (form.type === 'Account Decrease') {
      formClasses += 'Decrease';
    } else if (form.type === 'New Account') {
      formClasses += 'New';
    } else if (form.type === 'Crew Change') {
      formClasses += 'CrewChange';
    } else if (form.type === 'Account Credit') {
      formClasses += 'Credit';
    } else if (form.type === 'Additional Service') {
      formClasses += 'Additional';
    } else if (form.type === 'Account Cancellation') {
      formClasses += 'Cancellation';
    }

    let importantItem = '';

    if (form.type === "New Account") {
      console.log(form['Franchise']);
      if (this.props.spList && this.props.spList.length > 0) {
        importantItem = form['Franchise'] + ' ($' + form['Monthly Amount'] + ')';
      }
    } else if (form.type === 'Account Increase' || form.type === 'Account Decrease') {
      importantItem = "From $" + form['Old Monthly'] + ' to $' + form['New Monthly'] + '';
    } else if (form.type === 'Crew Change') {
      let newSP = '';
      let oldSP = '';
      console.log(form);
      if (this.props.spList && this.props.spList.length > 0) {
        newSP = this.props.spList.filter(e => e.fields['Number'] === form['New Crew']);
        oldSP = this.props.spList.filter(e => e.fields['Number'] === form['Old Crew']);
        console.log(newSP);
        console.log(oldSP);
        
        // newSP = this.props.spList.filter(e => e.fields['Number'] === form['New Crew'])[0].fields['SP Name'];
        // oldSP = this.props.spList.filter(e => e.fields['Number'] === form['Old Crew'])[0].fields['SP Name'];
      }

      importantItem = oldSP + ' => ' + newSP;
    } else if (form.type === 'Account Credit') {
      let charge = 'No Charge';
      if (form['Charge'].includes('Yes')) {charge = 'Charge SP'}
      importantItem = charge + ' for ' + form['Services Missed'] + ' missed';
    } else if (form.type === 'Additional Service') {
      importantItem = "$" + form['Total Price'] + " for " + form['Services'].length + ' service(s)';
    } else if (form.type === 'Account Cancellation') {
      importantItem = form['Franchise'] + ' (' + form['Replaceable'] + ')';
    }

    return (
      //onClick={()=>this.openForm(form)}
      <div className={formClasses} id={'form-'+ i} onClick={()=>window.find(form.date)}>
        <p className="formType">{form.type} <span>| {importantItem}</span></p>

        <p className="formDate">{formDate}</p>
        <p className="formHighlight">{form.highlight}</p>
      </div>
    )
  }
}

FormsList.propTypes ={
  currentRecord: propTypes.object.isRequired,
  baseId: propTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/CustomerService/Records/Modules/FormsList.js